<template>
  <div :height="true" class="showTask">
    <div class="flex">
      <div class="flex-form-wrap">
        <div class="flex-form-items">
          <div class="task-container">
            <el-form :model="baseInfo" ref="taskRuleForm" :rules="baseInfoRules" label-width="90px" label-position="right">
              <el-form-item label="调查员:">
                <span v-if="['add','edit'].includes(showTaskType)">{{ baseInfo.executorName }}</span>
                <span v-else-if="['batchAdd'].includes(showTaskType)">{{showTaskRows.length > 1 ? `已选中${showTaskRows.length}人`: showTaskRows[0].executorName }}</span>
              </el-form-item>
              <el-form-item v-if="['add','edit'].includes(showTaskType)" label="手机号码:">
                <span>{{ baseInfo.executorPhone }}</span>
              </el-form-item>
              <el-form-item :style="{ marginBottom: '0' }" label="结算类型:" prop="settleMethod">
                <div class="flex">
                  <div class="inline-block">
                    <div class="btn-box btn1 box-border" :class="{ 'btn-checked': btnChecked == 'online' }" @click="changeSettleMethod('online')">
                      <el-checkbox class="position-checkbox" :disabled = "!(btnChecked == 'online')" :value="true"></el-checkbox>
                      <div>
                        <div class="text-theme-black-650 text-medium mb-2 font-semibold">线上结算
                          <div class="tujian bg-yellow-theme text-white inline-block text-center font-semibold text-small">
                            推荐
                          </div>
                        </div>
                        <div class="text-theme-black-450 text-small">线上支付调查员费用，调研工厂代调查员纳税，并为您的总花费开具发票</div>
                        <div class="flex justify-between mt-1" v-if="!isOpen">
                          <span class="text-yellow-theme text-small">
                            <i class="iconfont icon-jingshishuoming text-small font-semibold"></i>
                            尚未开通，无法使用
                          </span>
                          <span class="cursor-pointer text-theme text-small" @click="toOpen">去开通></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="inline-block">
                    <div class="btn-box btn2 box-border" :class="{ 'btn-checked': btnChecked == 'offline' }" @click="changeSettleMethod('offline')">
                      <el-checkbox class="position-checkbox" :disabled = "!(btnChecked == 'offline')" :value="true"></el-checkbox>
                      <div>
                        <div class="text-theme-black-650 text-medium mb-2 font-semibold">线下结算</div>
                        <div class="text-theme-black-450 text-small">常用场景:线下与调查员签署劳务协议、协商支付方式、纳税事宜等</div>
                      </div>
                    </div>
                  </div>
                  <div class="inline-block">
                    <div class="btn-box btn2 box-border" :class="{ 'btn-checked': btnChecked == 'neednot' }" @click="changeSettleMethod('neednot')">
                      <el-checkbox class="position-checkbox" :disabled = "!(btnChecked == 'neednot')" :value="true"></el-checkbox>
                      <div>
                        <div class="text-theme-black-650 text-medium mb-2 font-semibold">无需结算</div>
                        <div class="text-theme-black-450 text-small">常用场景:已同调查员签署劳动合同或调查员愿提供无偿服务等</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item
                :style="{ marginBottom: baseInfo.settleMode ? '0' : '18px' }"
                label="结算方式:"
                prop="settleMode"
                :rules="[{ required: !((!isOpen&&baseInfo.settleMethod==0)), message: ' ', trigger: 'change' }]"
              >
                <el-radio-group v-model="baseInfo.settleMode" @change="changeSettlementType" :disabled="(!isOpen&&baseInfo.settleMethod==0)">
                  <el-radio :label="1">按答卷数量</el-radio>
                  <el-radio :label="2">按天</el-radio>
                  <el-radio v-if="!(btnChecked == 'neednot')" :label="3">按阶梯计价</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="settlementType-style-wrap" v-if="baseInfo.settleMode === 1">
                <div class="settlementType-style" style="margin: 8px 0 16px" v-if="baseInfo.settleMode === 1">
                  <div class="flex-box" v-if="baseInfo.settleMethod!=2">
                    <el-form-item
                      label="单价（元）:"
                      label-width="110px"
                      prop="settleRule.unitPriceYuan"
                      :rules="[{ required: !((!isOpen&&baseInfo.settleMethod==0)||baseInfo.settleMethod==2), message: ' ', trigger: 'blur' }]"
                    >
                      <el-input-number
                        placeholder=""
                        v-model="baseInfo.settleRule.unitPriceYuan"
                        autocomplete="off"
                        controls-position="right"
                        :min="1"
                        :max="Infinity"
                        :precision="2"
                        :disabled="(!isOpen&&baseInfo.settleMethod==0)||baseInfo.settleMethod==2"
                      >
                      </el-input-number>
                    </el-form-item>
                    <span>元</span>
                  </div>
                  <div class="settlement-tips" v-if="baseInfo.settleMethod!=2">
                    若用线上结算，请填写调查员到手金额，到手金额
                    <el-button type="text" @click="$emit('dialogChange', true)">计算器</el-button>
                  </div>
                  <div class="flex-box">
                    <span class="pos-abs-box">
                      <i>*</i>
                      答卷数量:
                      <el-tooltip
                        effect="dark"
                        content="该数量仅为参考回收数量，调查员可超额上报答卷，您可与调查员线下协商上报数量，采用线上结算时，可按照实际上报答卷数量进行结算"
                        placement="top"
                      >
                        <div class="icon-wrap" style="margin-left: 4px">
                          <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                        </div>
                      </el-tooltip>
                    </span>
                    <el-form-item
                      label=""
                      label-width="110px"
                      prop="settleRule.expectedQuantity"
                      :rules="[{ required: !((!isOpen&&baseInfo.settleMethod==0)), message: ' ', trigger: 'blur' }]"
                    >
                      <el-input-number
                        placeholder=""
                        v-model="baseInfo.settleRule.expectedQuantity"
                        autocomplete="off"
                        controls-position="right"
                        :min="1"
                        :max="Infinity"
                        :precision="0"
                        :disabled="(!isOpen&&baseInfo.settleMethod==0)"
                      >
                      </el-input-number>
                    </el-form-item>
                    <span>份</span>
                  </div>
                  <div class="settlement-tips" style="margin-bottom: 0" v-if="baseInfo.settleMethod!=2">
                    预估费用:{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元
                  </div>
                </div>
              </div>
              <div class="settlementType-style-wrap" v-if="baseInfo.settleMode === 2">
                <div class="settlementType-style" style="margin: 8px 0 16px" v-if="baseInfo.settleMode === 2">
                  <div class="flex-box" v-if="baseInfo.settleMethod!=2">
                    <el-form-item
                      label="单价（元）:"
                      prop="settleRule.unitPriceYuan"
                      label-width="110px"
                      :rules="[{ required: !((!isOpen&&baseInfo.settleMethod==0)||baseInfo.settleMethod==2), message: ' ', trigger: 'blur' }]"
                    >
                      <el-input-number
                        placeholder=""
                        v-model.number="baseInfo.settleRule.unitPriceYuan"
                        autocomplete="off"
                        controls-position="right"
                        :min="1"
                        :max="Infinity"
                        :precision="2"
                        :disabled="(!isOpen&&baseInfo.settleMethod==0)||baseInfo.settleMethod==2"
                      >
                      </el-input-number>
                    </el-form-item>
                    <span>元</span>
                  </div>
                  <div class="settlement-tips" v-if="baseInfo.settleMethod!=2">
                    若用线上结算，请填写调查员到手金额，到手金额
                    <el-button type="text" @click="$emit('dialogChange', true)">计算器</el-button>
                  </div>
                  <div class="flex-box">
                    <span class="pos-abs-box">
                      <i>*</i>
                      天数:
                      <el-tooltip
                        effect="dark"
                        content="当天只要上报答卷即记为工作 1 天，该天数仅为参考工作天数，您可与调查员线下协商工作天数，采用线上结算时，可按照实际工作天数进行结算"
                        placement="top"
                      >
                        <div class="icon-wrap" style="margin-left: 4px">
                          <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                        </div>
                      </el-tooltip>
                    </span>
                    <el-form-item
                      label=""
                      label-width="110px"
                      prop="settleRule.expectedQuantity"
                      :rules="[{ required: !((!isOpen&&baseInfo.settleMethod==0)), message: ' ', trigger: 'blur' }]"
                    >
                      <el-input-number
                        placeholder=""
                        v-model.number="baseInfo.settleRule.expectedQuantity"
                        autocomplete="off"
                        controls-position="right"
                        :min="1"
                        :max="Infinity"
                        :precision="0"
                        :disabled="(!isOpen&&baseInfo.settleMethod==0)"
                      >
                      </el-input-number>
                    </el-form-item>
                    <span>天</span>
                  </div>
                  <div class="settlement-tips" style="margin-bottom: 0" v-if="baseInfo.settleMethod!=2">
                    <div style="display: flex">
                      <div>预估费用:{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元</div>
                      <el-tooltip
                        effect="dark"
                        :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
                        placement="top"
                      >
                        <div class="icon-wrap">
                          <span class="icon-font ico-tips">&#xe65b;</span>
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <div class="settlementType-style-wrap" v-if="baseInfo.settleMode === 3">
                <div class="settlementType-style" style="margin: 8px 0 16px" v-if="baseInfo.settleMode === 3">
                  <el-form-item class="is-require-task" style="margin-bottom: 0" label-width="110px" label="单价（元）:" v-if="baseInfo.settleMethod!=2">
                    <div
                      class="flex-settlement"
                      v-for="(item, index) in baseInfo.settleRule.tiers"
                      :key="index"
                      :style="{ marginBottom: index === baseInfo.settleRule.tiers.length - 1 ? '0px' : '5px' }"
                    >
                      <span style="margin-right: 8px" v-show="index === 0">每天</span>
                      <el-form-item label>
                        <el-input-number
                          v-if="index === 0"
                          :disabled="true"
                          placeholder=""
                          v-model="item.quantityLowerBound"
                          autocomplete="off"
                          controls-position="right"
                          :min="0"
                          :max="Infinity"
                          :precision="0"
                        >
                        </el-input-number>
                        <el-input-number
                          v-if="index > 0"
                          :disabled="true"
                          placeholder=""
                          :value="baseInfo.settleRule.tiers[index - 1].quantityUpperBound"
                          autocomplete="off"
                          controls-position="right"
                          :min="0"
                          :max="Infinity"
                          :precision="0"
                        >
                        </el-input-number>
                      </el-form-item>
                      <span style="margin: 0 8px">份 &lt; 完成量 ≤</span>
                      <el-form-item
                        label
                        :prop="'settleRule.tiers[' + index + '].quantityUpperBound'"
                        :rules="[{ required: !((!isOpen&&baseInfo.settleMethod==0)||baseInfo.settleMethod==2), message: ' ', trigger: 'blur' }]"
                      >
                        <el-input-number
                          placeholder=""
                          v-model="item.quantityUpperBound"
                          autocomplete="off"
                          controls-position="right"
                          :min="index > 0 ? baseInfo.settleRule.tiers[index - 1].quantityUpperBound * 1 + 1 : 1"
                          :max="Infinity"
                          @change="val => currentInputNumber(val, item, index)"
                          :precision="0"
                          :disabled="(!isOpen&&baseInfo.settleMethod==0)||baseInfo.settleMethod==2"
                        >
                        </el-input-number>
                      </el-form-item>
                      <span style="margin: 0 8px">份，按完成量</span>
                      <el-form-item
                        label
                        :prop="'settleRule.tiers[' + index + '].unitPriceYuan'"
                        :rules="[
                          {
                            required: !((!isOpen&&baseInfo.settleMethod==0)||baseInfo.settleMethod==2),
                            message: ' ',
                            trigger: 'blur'
                          }
                        ]"
                        style="margin-left: 10px"
                      >
                        <el-input-number
                          placeholder=""
                          v-model.number="item.unitPriceYuan"
                          autocomplete="off"
                          controls-position="right"
                          :min="1"
                          :max="Infinity"
                          :precision="2"
                          :disabled="(!isOpen&&baseInfo.settleMethod==0)||baseInfo.settleMethod==2"
                        >
                        </el-input-number>
                      </el-form-item>
                      <span style="margin-left: 8px">元/份</span>
                      <el-button v-if="index === 0" @click="handleSettlement('add', index)" class="btn-style" type="text"
                        ><i class="icon-font">&#xe68c;</i></el-button
                      >
                      <el-button
                        v-else-if="index === baseInfo.settleRule.tiers.length - 1"
                        @click="handleSettlement('remove', index)"
                        class="btn-style"
                        type="text"
                        ><i class="icon-font">&#xe68a;</i></el-button
                      >
                    </div>
                    <div class="settlement-tips left-0">
                      若用线上结算，请填写调查员到手金额，到手金额
                      <el-button type="text" @click="$emit('dialogChange', true)">计算器</el-button>
                    </div>
                  </el-form-item>
                  <div class="flex-box">
                    <el-form-item
                      style="margin-bottom: 0"
                      label="天数:"
                      label-width="110px"
                      prop="settleRule.expectedQuantity"
                      :rules="[{ required: !((!isOpen&&baseInfo.settleMethod==0)), message: ' ', trigger: 'blur' }]"
                    >
                      <el-input-number
                        placeholder=""
                        v-model.number="baseInfo.settleRule.expectedQuantity"
                        autocomplete="off"
                        controls-position="right"
                        :min="1"
                        :max="Infinity"
                        :precision="0"
                        :disabled="(!isOpen&&baseInfo.settleMethod==0)"
                      >
                      </el-input-number>
                    </el-form-item>
                    <span>天</span>
                  </div>
                </div>
              </div>  
              <el-row :gutter="6">
                <el-col :span="12">
                  <el-form-item label="任务名称:" prop="executionName">
                    <el-input placeholder="请输入任务名称" v-model="baseInfo.executionName" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="executionValidateTo" label="截止时间:">
                    <el-date-picker
                      class="el-form-input"
                      type="datetime"
                      placeholder="选择日期"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="baseInfo.executionValidateTo"
                      :picker-options="startDateDisabled"
                    />
                  </el-form-item>
                </el-col>
              </el-row> 
              <el-col :span="24">
                <el-form-item label="描述:">
                  <el-input placeholder="请输入描述" v-model="baseInfo.executionDescription"></el-input>
                </el-form-item>
              </el-col> 
              <el-col :span="24">
                <el-form-item label="执行要求:" prop="executionRequirement">
                  <el-input placeholder="请输入执行要求" v-model="baseInfo.executionRequirement" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="质控标准:" prop="qualityControlStandard">
                  <el-input placeholder="请输入质控标准" v-model="baseInfo.qualityControlStandard" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="24">
                <el-form-item label="结算标准:" prop="settleStandard">
                  <el-input placeholder="请输入质控标准" v-model="baseInfo.settleStandard" autocomplete="off"></el-input>
                </el-form-item>
              </el-col> -->
            </el-form>
          </div>
          <div class="sample-component">
            <AddSampleList :sampleDetails="baseInfo.sampleDetails || null" :jobForm="baseInfo.jobForm" :currentPage="showTaskPage" :showTaskType="showTaskType" isHaveTask :activeCallType="activeCallType" @selectionChangeEmit="selectionChangeEmit" ref="addSampleList"/>
          </div>
        </div>
        <div class="flex-form-btns">
          <div>
            <div class="settlement-tips" style="margin-bottom: 0" v-if="baseInfo.settleMethod!=2">
              {{baseInfo.settleMethod === 0 ? '线上' : '线下'}}结算预估花费:<span>{{baseInfo.settleMethod === 0 ? totalSaleYuan : totalPriceYuan}}</span>元
            </div>
          </div>
          <div>
            <el-button class="normal-button default_btn" @click="$emit('cancel')">取消</el-button>
            <el-button class="normal-button" type="primary" @click="onClickSubmit">确定</el-button>
          </div>
        </div>
      </div>
      <div class="right-adv">
        <Advert></Advert>
      </div>
    </div>
  </div>
</template>

<script>
import { isNum } from '@/assets/js/utils'
import { putOfflineTask, postAssignSampleOfflineTask } from '@/api/wenjuan/offline'
import { getPhoneTask } from '@/api/wenjuan/telephone'
import store from '@/store'
import GlobalConfig from '@/global/config'
import Advert from '@/components/interview/advert/index.vue'
import AddSampleList from '@/views/survey/offline/components/drawer/AddSampleList'
import { creatPhoneTask } from '@/api/wenjuan/telephone.js'
import { putTask } from '@/api/wenjuan/telephone.js'
export default {
  name: 'showTask',
  props: {
    rows: {
      type: Object,
      default: () => {}
    },
    showTaskType:{
      type: String,
      default: ''
    },
    showTaskRows:{
      type: Array,
      default: []
    },
    showTaskPage:{
      type: String,
      default: ''
    },
    activeCallType: {
      type: [String, Number],
      default: null
    },
  },
  components:{ Advert, AddSampleList },
  data() {
    const startDateDisabled = {}
    startDateDisabled.disabledDate = function (time) {
      return time.getTime() + 24 * 3600 * 1000 < Date.now()
    }
    return {
      settleMethodMap: {
        'online':0,
        'offline':1,
        'neednot':2
      },
      btnCheckedMap: {
        0:'online',
        1:'offline',
        2:'neednot'
      },
      btnChecked: 'online',
      isOpen: false,
      tableData: [],
      startDateDisabled,
      taskInfo: null,
      baseInfoRules: {
        executionName: [{ required: true, message:'请输入任务名称', trigger: 'blur' }],
        executionValidateTo: [{ required: true, message:'请选择截止时间', trigger: 'change' }],
        // qualityControlStandard:[{ required: true, message:'请输入质控标准', trigger: 'blur' }]
      },
      baseInfo: {
        executorName:'', // 调查员
        executionName: '', // 任务名称
        executorPhone: '', // 手机号码
        executionValidateTo: '', // 截止日期
        executionDescription: '', // 描述
        settleMethod: 0, // 结算类型
        settleMode: 1,  // 结算方式
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      },
      type: 0,
      group: 0,
      groupName: '',
      checkedSeetingFields: [], // 勾选字段
      checkBoxData: [],  // 字段集合
    }
  },
  computed: {
    totalPriceYuan () {
      if (this.baseInfo.settleRule.expectedQuantity && this.baseInfo.settleRule.unitPriceYuan) {
        if(this.showTaskRows.length === 0){
          return (this.baseInfo.settleRule.expectedQuantity * this.baseInfo.settleRule.unitPriceYuan).toFixed(2) 
        } else{
          return (this.baseInfo.settleRule.expectedQuantity * this.baseInfo.settleRule.unitPriceYuan * this.showTaskRows.length).toFixed(2) 
        }
      } else {
        return 0
      }
    },
    totalSaleYuan () {
      if (this.baseInfo.settleRule.expectedQuantity && this.baseInfo.settleRule.unitPriceYuan) {
        if(this.showTaskRows.length === 0){
          return ((1 + this.accRate * 1) * (this.baseInfo.settleRule.expectedQuantity * this.baseInfo.settleRule.unitPriceYuan)).toFixed(2)
        } else{
          return ((1 + this.accRate * 1) * (this.baseInfo.settleRule.expectedQuantity * this.baseInfo.settleRule.unitPriceYuan * this.showTaskRows.length)).toFixed(2)
        }
      } else {
        return 0
      }
    },
    accountingRateVal() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '6.5%' : `${accountingRate}%`
    },
    accRate() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '0.065' : (accountingRate / 100).toFixed(3)
    }
  },
  methods: {
    toOpen() {
      window.open(
        `${window.location.origin + process.env.VUE_APP_PRE_URL}/#/cost-settlement`
      )
    },
    changeSettleMethod(btnType) {
      this.btnChecked = btnType
      this.baseInfo.settleMethod = this.settleMethodMap[btnType]
      this.changeSettlementType(1)
    },
    onClickSubmit() {
      if(!this.isOpen&&this.baseInfo.settleMethod==0) {
        this.$message({
          message: '尚未开通费用结算，无法设定线上结算',
          type: 'warning'
        });
        return
      }   
      this.$confirm('确定保存修改内容?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let taskInfo = this.baseInfo
          // 处理阶梯计价开始数量
          let postData = {}
          if (this.baseInfo.settleMode === 3) {
            const cloneLadderSettlement = [...this.baseInfo.settleRule.tiers]
            cloneLadderSettlement.forEach((it, i, arr) => {
              if (i > 0) {
                it.quantityLowerBound = arr[i - 1].quantityUpperBound * 1
              }
            })
            postData = {
              ...this.baseInfo,
              settleRule: {
                ...this.baseInfo.settleRule,
                tiers: cloneLadderSettlement
              }
            }
            // postData.ladderSettlement =cloneLadderSettlement;
            this.baseInfo = { ...postData }
          }
          let validateFlag = false;
          this.$refs['taskRuleForm'].validateField(['executionName','executionValidateTo','qualityControlStandard'],(valid)=> {
            if(!valid){
              validateFlag = true;
            }else{
              validateFlag = false;
            }
          })
          if(validateFlag && this.validateSampleDetails()){
            // 电话访问添加
            if(this.showTaskPage === 'telephoneInterviewer' && this.showTaskType === 'edit'){
              this.editTask();
              // 电话访问编辑
            }else if(this.showTaskPage === 'telephoneInterviewer' && this.showTaskType === 'add'){
              this.crateTask();
              // 电话访问批量分配
            }else if(this.showTaskPage === 'telephoneInterviewer' && this.showTaskType === 'batchAdd'){
              this.batchTask();
              // 指定样本添加
            }else if(this.showTaskPage === 'assignSample' && this.showTaskType === 'add'){
              this.assignSampleCrateTask();
              // 指定样本编辑
            }else if(this.showTaskPage === 'assignSample' && this.showTaskType === 'edit'){
              this.assignSampleEditTask();
            }
          }else{
            this.$message.warning('请完善表单数据及样本添加')
          }
        })
        .catch(() => {
          this.initInfo()
        })
    },
    initInfo() {
      if(this.showTaskType === 'add'){
        console.log('this.taskInfo-add',this.taskInfo);
        this.baseInfo = {
        executorName: this.taskInfo.executorName,
        executionName: '',
        executorPhone: this.taskInfo.executorPhone,
        executionValidateTo: '',
        executionDescription: '',
        qualityControlStandard: '',
        settleStandard: '',
        settleMethod: 0,
        settleMode: 1,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      }
      }else if(this.showTaskType === 'edit'){
        this.baseInfo = {
          id: this.taskInfo.offlineId,
          executorName: this.taskInfo.executorName,
          executionName: this.taskInfo.executionName,
          executorPhone: this.taskInfo.executorPhone,
          executionValidateTo: this.taskInfo.executionValidateTo,
          executionDescription: this.taskInfo.executionDescription,
          qualityControlStandard: this.taskInfo.qualityControlStandard,
          executionRequirement:this.taskInfo.executionRequirement,
          settleStandard: this.taskInfo.settleStandard,
          settleMethod: this.taskInfo.settleMethod || 0,
          settleMode: this.taskInfo.settleMode,
          settleRule: this.taskInfo.settleRule || {
            unitPriceYuan: undefined, //单价 多少元/天  多少元/份
            expectedQuantity: undefined, // 数量 多少份 | 多少天
            tiers: [
              {
                quantityLowerBound: 0,
                quantityUpperBound: undefined,
                unitPriceYuan: undefined
              }
            ]
          },
          sampleDetails: {...this.taskInfo.sampleDetails,id:this.taskInfo.id },
          jobForm: this.taskInfo.jobForm
          // 设置样本回显数据 后期删除
          // "sampleDetails": {
          //   "tableData": [{
          //     "0": "李净妍",
          //     "1": "13988887777",
          //     "2": "女",
          //     "3": "大学",
          //     "4": "北京/北京/海淀区",
          //     "id": "559392150526099456"
          //   }, {
          //     "0": "刘博",
          //     "1": "13988887778",
          //     "2": "男",
          //     "3": "大学",
          //     "4": "河北省/石家庄市/雄安新区",
          //     "id": "559392150526099457"
          //   }],
          //   "type": 1,
          //   "group": 640,
          //   "groupName": "测试群组yy企业",
          //   "checkedSeetingFields": ["645994592667172864", "645994600997060608", "645994855389986816", "645995465879322624", "645995037506666496"],
          //   "checkBoxData": [{
          //     "label": "姓名",
          //     "value": "645994592667172864",
          //     "disabled": true
          //   }, {
          //     "label": "手机号",
          //     "value": "645994600997060608",
          //     "disabled": true
          //   }, {
          //     "label": "性别",
          //     "value": "645994855389986816",
          //     "disabled": true
          //   }, {
          //     "label": "学历",
          //     "value": "645995465879322624",
          //     "disabled": true
          //   }, {
          //     "label": "您的常住地址",
          //     "value": "645995037506666496",
          //     "disabled": true
          //   }]
          // }
        }
      }else if(this.showTaskType === 'batchAdd'){
        console.log('this.showTaskRows',this.showTaskRows)
      }
      this.btnChecked = this.btnCheckedMap[this.baseInfo.settleMethod]
    },
    // 监听input-number值的变化
    currentInputNumber(val, item, currentIndex) {
      const baseSettleRule = JSON.parse(JSON.stringify(this.baseInfo.settleRule))
      baseSettleRule.tiers.forEach((it, i, arr) => {
        if (i > currentIndex) {
          it.quantityUpperBound = arr[i - 1].quantityUpperBound + 1
        }
      })
      this.baseInfo.settleRule = {
        ...this.baseInfo.settleRule,
        tiers: baseSettleRule.tiers
      }
    },
    // 切换结算方式
    changeSettlementType(val) {
      this.$refs['taskRuleForm'].clearValidate()
      this.baseInfo = {
        ...this.baseInfo,
        settleMode: val,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      }
    },
    handleSettlement(type, index) {
      console.log(type)
      if (type === 'add') {
        const validateArr = []
        this.baseInfo.settleRule.tiers.forEach((it, i) => {
          validateArr.push(`settleRule.tiers[${i}].quantityUpperBound`)
          validateArr.push(`settleRule.tiers[${i}].unitPriceYuan`)
        })
        let validFlag = false
        validateArr.forEach(item => {
          this.$refs['taskRuleForm'].validateField(
            validateArr,
            valid => (validFlag = valid ? false : true) // 定义是否通过表单验证
          )
        })
        console.log('validateArr:', validateArr)
        if (validFlag) {
          if (this.baseInfo.settleRule.tiers.length < 5) {
            const lastTiers = this.baseInfo.settleRule.tiers[this.baseInfo.settleRule.tiers.length - 1]
            const lastObj = { quantityUpperBound: lastTiers.quantityUpperBound, unitPriceYuan: lastTiers.unitPriceYuan }

            const flagDouble = Object.values(lastObj).includes(undefined)
            if (flagDouble) {
              this.$message.error('请完善表单项')
              return
            }
            const cloneLadderSettlement = this.baseInfo.settleRule.tiers
            cloneLadderSettlement.push({
              quantityLowerBound: undefined,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            })
            this.baseInfo.settleRule.tiers = cloneLadderSettlement
          } else {
            this.$message.error('最多只能添加5条数据')
          }
        } else {
          this.$message.error('请完善表单项')
        }
      } else if (type === 'remove') {
        const cloneLadderSettlement = this.baseInfo.settleRule.tiers

        this.baseInfo.settleRule.tiers = cloneLadderSettlement.filter((it, i) => index !== i)
      }
    },
    /**
     * 
     * @param {Array} data 勾选数据
     * @param {Number} type 群组类型
     * @param {Number} group 群组名称Id
     * @param {String} groupName 群组名称
     * @param {Array} checkedSeetingFields 勾选字段
     */
    selectionChangeEmit(data, type, group, groupName, checkedSeetingFields, checkBoxData){
      this.tableData = data;
      this.type = type;
      this.group = group;
      this.groupName = groupName;
      this.checkedSeetingFields = checkedSeetingFields;
      this.checkBoxData = checkBoxData;
    },
    // 电话访问添加任务
    crateTask(){
      let params = {
        execution:{
          ...this.baseInfo,
          surveyId: this.taskInfo.surveyId,
          userList:[{
            userId: this.taskInfo.executionBy,
            userName: this.baseInfo.executorName || '',
            phone: this.baseInfo.executorPhone,
            justForCode: 'true'
          }]
        },
        
        jobFrom: this.$refs.addSampleList.callType,
        phoneList: []
      };
      //如果添加预测式外呼任务且已经有过预测式外呼任务，调用 /addPhoneList 这个接口时不传 sampleDetails。为了用户能自己加调查员。
      if( this.activeCallType !== 5 ) {
        params = {
          ...params,
          ...this.handleSampleDetailsParams()
        }
      };
      if(this.showTaskType === 'batchAdd'){
        const userList = this.showTaskRows.map(it=> ({
          userId: it.executionBy,
          userName: it.executorName || '',
          phone: it.executorPhone,
          justForCode: 'true'
        }))
        params.execution.userList = userList;
        params.execution.surveyId = this.showTaskRows[0].surveyId;
      }
      creatPhoneTask(params).then(res=> {
        if(res.data.code === 0){
          this.$message.success('添加任务成功');
          this.$emit('callbackClose', false , true);
        }else{
          this.$message.error(res.data.msg);
        }
      })
    },
    editTask(){
      putOfflineTask({
        ...this.baseInfo,
        id: this.taskInfo.id,
        executionBy: this.taskInfo.executionBy,
        ...this.handleSampleDetailsParams(),
      })
      .then(res => {
        if (res.data.code != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.$message({
          type: 'success',
          message: '保存成功!'
        })
        this.$emit('callbackClose', false , true);
      })
    },
    // 电话访问批量添加
    batchTask(){
      this.crateTask();
    },
    // 指定面访添加任务
    assignSampleCrateTask(){
      postAssignSampleOfflineTask({
        ...this.baseInfo,
        executionBy: this.taskInfo.executionBy,
        userName: this.baseInfo.executorName,
        surveyId: this.taskInfo.surveyId,
        sampleIdList: this.tableData.map(it=> (it.id)),
        ...this.handleSampleDetailsParams()

      }).then(res=> {
        if(res.data.code === 0){
          this.$message({
            type: 'success',
            message: '保存成功!'
          })
          this.$emit('callbackClose', false , true);
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    // 指定面访编辑任务
    assignSampleEditTask(){
      console.log('this.tableData',this.tableData)
      putTask({
        ...this.baseInfo,
        id: this.taskInfo.id,
        executionBy: this.taskInfo.executionBy,
        // tableData: this.tableData,
        // type : this.type,
        // group : this.group,
        // groupName : this.groupName,
        // checkedSeetingFields: this.checkedSeetingFields,
        // checkBoxData: this.checkBoxData
        ...this.handleSampleDetailsParams()

      }).then(res=> {
        if(res.data.code === 0){
          this.$message({
            type: 'success',
            message: '保存成功!'
          })
          this.$emit('callbackClose', false , true);
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    // 校验样本数据
    validateSampleDetails(){
      if(this.$refs.addSampleList.tableData instanceof Array && this.$refs.addSampleList.tableData.length > 0 || this.activeCallType === 5){
        return true
      }else {
        // this.$message.error('请添加样本数据');
        return false
      }
    },
    //处理样本添加数据
    handleSampleDetailsParams() {
      return {
        sampleDetails:{
          tableData: this.$refs.addSampleList.tableData,
          type : this.$refs.addSampleList.type,
          group : this.$refs.addSampleList.group,
          groupName : this.$refs.addSampleList.groupName,
          checkedSeetingFields: this.$refs.addSampleList.checkedSeetingFields,
          checkBoxData: this.$refs.addSampleList.checkBoxData
        }
      }
    }
  },
  created() {
    this.isOpen = this.$store.getters.settlementType !== 1
    console.log('this.rows', this.rows)
    this.taskInfo = this.rows
    this.initInfo()
  }
}
</script>

<style scoped lang="scss">
.flex-container {
  display: flex;
  justify-content: center;
  .phone-list {
    width: 360px;
  }
}
.showTask {
  height: 100%;
  background-color: #F5F5F5;
  .goback {
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }
  .flex{
    height:100%;
  }
  .sample-component{
    margin-bottom: 16px;
  }
  .flex-form-wrap{
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #fff;
    width: 880px; 
    .flex-form-items{
      flex: 1;
      overflow: auto;
      .task-container{
        padding: 16px;
        overflow: hidden;
        .settlementType-style-wrap{
          padding-left: 90px;
          .settlement-tips{
            margin-left: 110px;
            &.left-0{
              margin-left: 0;
            }
          }
        }
      }
    }
    .flex-form-btns{
      .settlement-tips{
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        span{
          color:#000;
          font-size: 22px;
          font-family: PingFangSC;
          font-weight: 500;
          margin: 0 5px;
        }
      }
      display: flex;
      justify-content:space-between;
      text-align: right;
      height: 64px;
      padding: 16px;
      box-sizing: border-box;
      border-top: 1px solid rgba(0,0,0,0.1);
      .default_btn{
        border-color: #ccc;
        color: rgba(0, 0, 0, 0.45);
      }
    }
  }
  .right-adv{
    margin-left: 16px;
    width: 290px;
    background: #fff;
    overflow: auto;
  }

  .base-info,
  .answer-info {
    @apply px-6 py-4;
    .top {
      font-size: 16px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }

    .el-form {
      width: 760px;
      // margin: 0 auto;
      margin-left: 24px;

      .el-form-item {
        // margin-bottom: 22px;
      }

      .el-form-input {
        width: 220px;
      }
    }
  }

  .submit-btn {
    margin-top: 30px;
    text-align: center;
  }
  .settlementType-style .flex-box .pos-abs-box {
    position: absolute;
    display: flex;
    justify-content: flex-end;
    width: 90px;
    padding-right: 12px;
    i {
      content: '*';
      color: #e34152;
      margin-right: 4px;
    }
  }
  .settlementType-style .flex-settlement .el-form-item {
    margin-bottom: 0 !important;
  }
}
.btn-box {
  @apply flex justify-center;
  padding: 10px;
  min-height: 116px;
  width: 200px;
  border-radius: 2px;
  cursor: pointer;
  line-height: 16px;
  position: relative;
  .position-checkbox{
    position: absolute;
    right: 0;
    top: -2px;
    }
  &.btn1 {
    border: 1px solid #cccccc;
  }
  &.btn2 {
    border: 1px solid #cccccc;
    margin-left: 12px;
  }
  &.btn1.btn-checked,
  &.btn2.btn-checked {
    background: rgba(39,117,232,0.10);
    border: 1px solid var(--theme-color) !important;
  }
  .tujian {
    border: 1px solid #FAAD14;
    border-radius: 8px;
    width: 34px;
    height: 16px;
    font-weight: 500;
    font-size: 12px;
  }
}
// .btn-checked div {
//   div {
//     color: #2775e8 !important;
//   }
//   i {
//     color: #2775e8 !important;
//   }
// }
.btn-box:hover {
  &.btn1,
  &.btn2 {
    background: rgba(39,117,232,0.10);
    border: 1px solid var(--theme-color) !important;
    // div {
    //   div {
    //     color: #2775e8 !important;
    //   }
    //   i {
    //     color: #2775e8 !important;
    //   }
    // }
  }
}
</style>
